const steps = [
  {
    num: "01",
    title: "Identify",
    copy: "Understand the brand, commercial objective and target audience.",
    testid: "process-step-1",
  },
  {
    num: "02",
    title: "Connect",
    copy: "Identify the most relevant sporting properties and decision-makers.",
    testid: "process-step-2",
  },
  {
    num: "03",
    title: "Structure",
    copy: "Develop the commercial proposition and partnership framework.",
    testid: "process-step-3",
  },
  {
    num: "04",
    title: "Deliver",
    copy: "Support discussions through to agreement and activation.",
    testid: "process-step-4",
  },
];

export default function ProcessSection() {
  return (
    <section className="bg-[#F7F6F2] text-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-28 lg:py-36">
        <p className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#0A0A0A] mb-6">
          04 — Process
        </p>
        <h2 className="font-heading font-light uppercase tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl mb-16">
          How We Work
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-14">
          {steps.map((s) => (
            <div
              key={s.num}
              data-testid={s.testid}
              className="pt-8 border-t-2 border-[#0A0A0A] hover:border-[#0A0A0A] transition-colors duration-200"
            >
              <span className="font-heading font-light text-5xl lg:text-6xl text-[#0A0A0A]">
                {s.num}
              </span>
              <h3 className="font-heading font-medium text-2xl tracking-tight mt-6 mb-3 uppercase">
                {s.title}
              </h3>
              <p className="text-sm sm:text-base text-neutral-600 font-light leading-relaxed">
                {s.copy}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
